import React, { useEffect } from "react";
import HeaderDrawer from "../../../common/components/HeaderDrawer";
import PowerBi from "../../components/PowerBi";

const PowerBiScreen = (props) => {
  useEffect(() => {
    // eslint-disable-next-line
  }, []);
  return (
    <HeaderDrawer name="Telas">
      <PowerBi accessToken={props.token} {...props} />
    </HeaderDrawer>
  );
};

export default PowerBiScreen;
